export default __webpack_public_path__ + "static/media/phone-preview-body.f876f4d1.svg";